import { useEffect, useState } from "react";
import posthog from "posthog-js";

/**
 * Subscribes to PostHog feature flag updates and returns whether `isEnabled()` is true.
 * Pass a stable checker (e.g. an imported function from `featureFlags.ts`).
 */
export function usePostHogFeatureFlag(isEnabled: () => boolean): boolean {
  const [enabled, setEnabled] = useState(() => isEnabled());

  useEffect(() => {
    setEnabled(isEnabled());
    const unsubscribe = posthog.onFeatureFlags?.(() => {
      setEnabled(isEnabled());
    });
    return () => unsubscribe?.();
  }, [isEnabled]);

  return enabled;
}
